/**
 * Отрисовочная сторона карт. Кодировка совпадает с движком:
 * карта — число 0..35, где id = индекс_масти * 9 + индекс_ранга.
 */

export const SUIT_SYMBOL = ["♠", "♥", "♦", "♣"] as const;
export const RANK_LABEL = ["6", "7", "8", "9", "10", "J", "Q", "K", "A"] as const;

/** Червы и бубны — красные. */
export function isRed(card: number): boolean {
  const s = suitIndex(card);
  return s === 1 || s === 2;
}

export function suitIndex(card: number): number {
  return Math.floor(card / 9);
}

export function rankIndex(card: number): number {
  return card % 9;
}

export function suitOf(card: number): string {
  return SUIT_SYMBOL[suitIndex(card)] ?? "?";
}

export function rankOf(card: number): string {
  return RANK_LABEL[rankIndex(card)] ?? "?";
}

/** Карты в руке: козыри вправо, внутри масти по возрастанию. */
export function sortHand(hand: number[], trumpSuitIndex: number): number[] {
  return [...hand].sort((a, b) => {
    const at = suitIndex(a) === trumpSuitIndex ? 1 : 0;
    const bt = suitIndex(b) === trumpSuitIndex ? 1 : 0;
    if (at !== bt) return at - bt;
    if (suitIndex(a) !== suitIndex(b)) return suitIndex(a) - suitIndex(b);
    return rankIndex(a) - rankIndex(b);
  });
}
